import request from '@/utils/request'

/**
 * 获取客户列表
 * @param {Object} params
 * @param {string} [params.customerType] 客户类型（投资方 / 业主方 / 渠道方）
 * @param {string} [params.customerName] 客户名称
 * @param {number|string} [params.pageNum] 页码
 * @param {number|string} [params.pageSize] 每页数量
 * @returns {Promise<AxiosResponse>}
 */
export function list(params) {
  return request({
    url: '/device/v3/customer/list',
    method: 'get',
    params,
  })
}

/**
 * 新增客户
 * @param {Object} data
 * @returns {Promise<AxiosResponse>}
 */
export function add(data) {
  return request({
    url: '/device/v3/customer',
    method: 'post',
    data,
  })
}

/**
 * 修改客户
 * @param {Object} data
 * @returns {Promise<AxiosResponse>}
 */
export function update(data) {
  return request({
    url: '/device/v3/customer',
    method: 'put',
    data,
  })
}

/**
 * 删除客户
 * @param {string|number} id
 * @returns {Promise<AxiosResponse>}
 */
export function del(id) {
  return request({
    url: `/device/v3/customer/${id}`,
    method: 'delete',
  })
}

/**
 * 导出客户信息（按查询条件导出）
 * @param {Object} params
 * @param {string} [params.customerType] 客户类型（投资方 / 业主方 / 渠道方）
 * @param {string} [params.customerName] 客户名称
 * @returns {Promise<Blob>}
 */
export function exportCustomer(params) {
  return request({
    url: '/device/v3/customer/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}
